import "core-js/modules/es.number.constructor";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-dataV-scrollList",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  data: function data() {
    return {
      config: {},
      uuid: null
    };
  },
  watch: {
    'option.attribute': {
      handler: function handler() {
        this.loadData();
      },
      deep: true //深度监听

    }
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "ScrollList").then(function (res) {
        _this.config = JSON.parse(JSON.stringify(_this.option.attribute));
        _this.config.data = res;
      });
    }
  }
};